import { TextInputProps } from "react-native"
import Input from ".."
export default (input: Input): TextInputProps => {
    return {
        ...input.props,
        secureTextEntry: false,
        autoCapitalize: "none",
        keyboardType: "numeric",
        onChangeText: (text) => {
            // Filtra para que solo queden números
            const numericText = text.replace(/[^0-9]/g, "");
            // input.handleChangeText(numericText);
            input.setValue(numericText);
        }
    }
}